import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useUserQuery } from "../queries";
import { ApiClient } from "services";

const UserContext = createContext({
  isAdmin: false,
  isUser: false,
  isAuthenticated: false,
  isAccounting: false,
  isPayroll: false,
  isWPConnect: false,
  isActive: false,
  user: null,
  query: null,
  isInTrialPeriod: false,
});

export const useUserContext = () => useContext(UserContext);

export const UserContextProvider = ({ children }) => {
  const query = useUserQuery();
  const { data: user, isLoading } = query;
  const client = ApiClient()

  const [permissions, setPermissions] = useState([])

  useEffect(async ()=>{
    
    if (user){
      var org_id = localStorage.getItem('hesaab/organisationId') || undefined
      if (!org_id){
        const orgs = await client.get('/connected_organisations')
        org_id = orgs?.data ? orgs.data[0].id : undefined
      }
      if (org_id){
        client.get(`/me/${org_id}/organisation_me`).then((response) => {
          setPermissions(response.data.permissions_codenames)
        }).catch((err) => {
          console.log('error at loading permissions', err)
      })
      }
    }
  }, [isLoading, user])
   
 
  const args = useMemo(() => {
    const isAdmin = !!user?.is_superuser;
    const isUser = !!(user && !isAdmin);
    const isAuthenticated = !!(isAdmin || isUser);
    const isAccounting = false;
    const isPayroll = false;
    const isWPConnect = false;
    // const isActive = !!(isAccounting || isPayroll || isWPConnect);
    const isActive = !!user?.is_active;
    const country = user?.country? user.country: "" 
    const isInTrialPeriod = (user?.trial_days_remaining > 0)

    return {
      isAdmin,
      isUser,
      isAuthenticated,
      isAccounting,
      isPayroll,
      isWPConnect,
      isActive,
      isInTrialPeriod,
      permissions:permissions,
      country:country,
    };
  }, [user, permissions]);

  if (isLoading) return null;

  const userData = user? {...user, permissions:permissions}: null

  return (
    <UserContext.Provider value={{ user:userData, query, ...{...args, permissions:permissions} }}>
      {children}
    </UserContext.Provider>
  );
};
